import React from "react";
import {Link} from "react-router-dom";

import ReactTable from "react-table";
import {Button} from "reactstrap";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";



export default class Locations extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Locations._name, API.RequestType.READ_ALL);
		super(props, model);
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if(this.props.reloadTable !== prevProps.reloadTable){
			window.location.reload();
		}
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Name",
				accessor: "name",
				Cell: props => !props.original.archived?<Link
					to={"/locations/" + props.original.binary_id + '-' + props.original.pkey}>{props.value}</Link>:props.value
			},
			{
				Header: "Display Name",
				accessor: "name_display",
			},
			{
				Header: "Address",
				accessor: "street_1",
			},
			{
				Header: "City",
				accessor: "city",
				width: 200,
			},
			{
				Header: "State",
				accessor: "state",
				width: 60,
			},
			{
				Header: "FFL #",
				accessor: "ffl",
				width: 200,
			},
			//TODO: status is subscription name
			{
				Header: "Subscription",
				id:"subscriptions_description",
				accessor: (obj) => {
					return obj.subscriptions ? (obj.subscriptions.description + (obj.subscription ? " ("+obj.subscription+")" : '')): "";
				},
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				show:this.props.showEdit,
				Cell: props => {
					return (
						<span>
							<Link to={`/locations/${props.original.binary_id+"-"+props.original.pkey}#details`}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className={"fa fa-pencil"}/></Button>
							</Link>
						</span>
					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Locations', "")}
							{this.renderHeaderRight("Locations", columns)}
						</div>
					</div>

					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={this.props.locations}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>


					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
